import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import {
  isDigitalLoanPreviewTarget,
  unlockDigitalLoanInternalPreview,
} from 'utils/digitalLoanPreviewAccess';

const CmsLink = ({
  to,
  children,
  className = '',
  external: propExternal = null,
  onClick = null,
}) => {
  const external = useMemo(() => (
    propExternal || ([null, undefined].includes(propExternal) && to?.startsWith('http'))
  ), [propExternal, to]);

  const handleClick = (e) => {
    if (external) {
      e.preventDefault();
      window.openExternalLink(to);
      if (onClick) {
        onClick(e);
      }
      return;
    }

    if (isDigitalLoanPreviewTarget(to)) {
      unlockDigitalLoanInternalPreview();
    }

    if (onClick) {
      onClick(e);
    }
  };

  return (
    <Link to={to} onClick={handleClick} className={className}>
      {children}
    </Link>
  );
};

CmsLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  external: PropTypes.bool,
  onClick: PropTypes.func,
};

export default CmsLink;
